module.exports = __webpack_public_path__ + "static/media/flagRed.60f0ab5f.svg";